const QualityCheckNeedsReviewIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48'
      height='36'
      viewBox='0 0 48 36'
      fill='none'
    >
      <g clipPath='url(#clip0_10375_283882)'>
        <path
          d='M47.9999 0H17.2803V2.4427C22.5735 4.16142 26.4002 9.1339 26.4002 15.0001C26.4002 20.8664 22.5735 25.8389 17.2803 27.5576V36.0003H47.9999V0Z'
          fill='#FFF3D3'
        />
        <path
          d='M26.348 16.1832C26.3826 15.7935 26.4003 15.3986 26.4003 15.0001C26.4003 14.1816 26.3253 13.3777 26.1826 12.6001H43.2005V16.2002H26.3466C26.347 16.1943 26.3476 16.189 26.348 16.1832Z'
          fill='#FFE3A5'
        />
        <path
          d='M25.5006 19.8002C24.9874 21.1133 24.2689 22.3274 23.3862 23.3967L23.3833 23.4002H40.8006V19.8002H25.5006Z'
          fill='#FFE3A5'
        />
        <path
          d='M24.961 9.00009H43.2005V6.00006H22.8564C23.6867 6.89069 24.396 7.89676 24.9563 8.99071C24.9579 8.99364 24.9593 8.99716 24.961 9.00009Z'
          fill='#FFE3A5'
        />
        <path
          d='M22.8003 26.4002H34.8004V30.0003H22.8003V26.4002Z'
          fill='#FFE3A5'
        />
        <path
          d='M17.1295 19.3863L21.1984 23.4543L19.8541 24.7985L15.7862 20.7297C14.2726 21.943 12.3899 22.603 10.45 22.6002C5.73034 22.6002 1.8999 18.7698 1.8999 14.0501C1.8999 9.3305 5.73034 5.50006 10.45 5.50006C15.1696 5.50006 19.0001 9.3305 19.0001 14.0501C19.0028 15.9901 18.3429 17.8727 17.1295 19.3863ZM15.2238 18.6814C16.4294 17.4416 17.1028 15.7796 17.1 14.0501C17.1 10.3755 14.1237 7.40008 10.45 7.40008C6.77535 7.40008 3.79992 10.3755 3.79992 14.0501C3.79992 17.7238 6.77535 20.7002 10.45 20.7002C12.1794 20.7029 13.8414 20.0296 15.0813 18.8239L15.2238 18.6814ZM11.5691 10.4173C11.289 10.5438 11.0437 10.7365 10.8544 10.9786C10.6651 11.2208 10.5373 11.5053 10.4821 11.8077C10.4269 12.11 10.4459 12.4213 10.5375 12.7147C10.629 13.0082 10.7904 13.275 11.0077 13.4924C11.2251 13.7097 11.4919 13.8711 11.7854 13.9627C12.0788 14.0542 12.3901 14.0732 12.6925 14.018C12.9949 13.9628 13.2793 13.8351 13.5215 13.6457C13.7637 13.4564 13.9563 13.2112 14.0828 12.931C14.3325 13.742 14.3035 14.6132 14.0006 15.4058C13.6977 16.1984 13.1382 16.8668 12.4113 17.3045C11.6844 17.7422 10.832 17.9241 9.98972 17.8211C9.14749 17.7181 8.36395 17.3361 7.76396 16.7362C7.16398 16.1362 6.78206 15.3526 6.67906 14.5104C6.57606 13.6682 6.75791 12.8157 7.19564 12.0888C7.63336 11.3619 8.30177 10.8024 9.09437 10.4995C9.88696 10.1966 10.7581 10.1676 11.5691 10.4173Z'
          fill='#FF910A'
        />
      </g>
      <defs>
        <clipPath id='clip0_10375_283882'>
          <rect width='48' height='36' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

QualityCheckNeedsReviewIcon.displayName = 'QualityCheckNeedsReviewIcon';

export default QualityCheckNeedsReviewIcon;
